export const LOAD_NOTES_LIST_ACTION = 'LOAD_NOTES_LIST_ACTION';
export const SET_EDITED_NOTE_ACTION = 'SET_EDITED_NOTE_ACTION';
export const SAVE_EDITED_NOTE_ACTION = 'SAVE_EDITED_NOTE_ACTION';
